<template>
  <BaseModal
    :show="show"
    @close="close"
  >
    <div class="modal-header">
      <header class="text-center pb-4 border-b border-grey">
        <h3
          class="mt-0 font-bold"
          v-text="'Create a new Membership Group'"
        />
      </header>
    </div>
    <div class="modal-body mb-8">
      <div>
        <input
          id="title"
          v-model="title"
          type="text"
          name="title"
          class="input"
          placeholder="Title"
          :class="{ 'error': hasErrorFor('title') }"
        >
        <div
          v-if="hasErrorFor('title')"
          class="my-0 -mt-4 mb-4"
        >
          <span
            class="field__meta__help"
            v-html="getErrorFor('title')"
          />
        </div>
        <textarea
          v-model="description"
          cols="30"
          placeholder="Description"
          rows="10"
        />
        <select v-model="type_id">
          <option
            v-for="membershipGroupType in membershipGroupTypes"
            :key="membershipGroupType.id"
            :value="membershipGroupType.id"
            v-text="membershipGroupType.title"
          />
        </select>
        <input
          id="selfAssignable"
          v-model="self_assignable"
          type="checkbox"
          name="selfAssignable"
        >
        <label
          for="selfAssignable"
          v-text="'Self assignable group'"
        />
        <input
          id="listInsideCalendarEvents"
          v-model="list_inside_calendar_events"
          type="checkbox"
          :disabled="disableListInsideCalendarEvents"
          :aria-disabled="disableListInsideCalendarEvents"
          name="listInsideCalendarEvents"
        >
        <label
          for="listInsideCalendarEvents"
          :class="{ 'text-grey-dark': disableListInsideCalendarEvents }"
          v-text="'List inside calendar events'"
        />
      </div>
    </div>
    <div class="modal-footer text-center mt-4">
      <button
        class="btn"
        type="button"
        @click="save"
        v-text="'Save'"
      />
      <button
        class="mx-4 text-blue underline"
        type="button"
        @click.prevent="close"
        v-text="'Cancel'"
      />
    </div>
  </BaseModal>
</template>

<script type="text/babel">
import { mapGetters } from 'vuex'
import ProcessValidationErrors from 'Base/Resources/assets/js/mixins/process-validation-errors'

export default {
  name: 'CreateMembershipGroupModal',
  mixins: [ProcessValidationErrors],
  props: {
    membershipGroupTypes: {
      type: Array,
      required: false,
      default: () => [],
    },
    groupsListedInsideCalendar: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      title: '',
      type_id: null,
      description: '',
      self_assignable: false,
      list_inside_calendar_events: false,
      folders: [],
    }
  },
  computed: {
    ...mapGetters([
      'totalMembershipCalendarGroups',
    ]),
    show() {
      return this.$store.state.membership.createMembershipGroupModal.open
    },
    disableListInsideCalendarEvents() {
      return this.groupsListedInsideCalendar.length >= 2 || this.totalMembershipCalendarGroups >= 2
    },
  },
  watch: {
    show() {
      if (this.show && !this.membershipGroupTypes.length) {
        this.$store.dispatch('membershipGetMembershipGroupTypes')
          .then(() => {
            this.presetType()
          })
      }
    },
  },
  async mounted() {
    await this.$nextTick()

    if (this.membershipGroupTypes.length) {
      this.presetType()
    }
  },
  methods: {
    presetType() {
      this.type_id = this.membershipGroupTypes[0].id
    },
    save() {
      this.$api.active().post('memberships/membership-groups', {
        title: this.title,
        description: this.description,
        type_id: this.type_id,
        self_assignable: this.self_assignable,
        list_inside_calendar_events: this.list_inside_calendar_events,
      }).then((response) => {
        this.$store.dispatch('membershipGetMembershipGroups')

        this.$store.commit('baseAddNotification', {
          type: 'success',
          title: 'Success',
          text: 'Membership group created!',
        })

        this.$emit('membershipGroupHasBeenCreated', response.data)

        this.close()
      }).catch((errors) => {
        this.validationErrors = errors.response.data
      })
    },
    close() {
      this.title = ''
      this.type_id = this.membershipGroupTypes[0].id
      this.description = ''
      this.self_assignable = false
      this.list_inside_calendar_events = false
      this.folders = []

      this.$store.commit('membershipCloseCreateMembershipGroupModal')
    },
  },
}
</script>
